import { createDispatchHook } from "react-redux";
import CoreReduxContext from "../contexts/CoreReduxContext";
import { CosmosCoreRootState } from "../store";

const useCoreDispatch =
  createDispatchHook<CosmosCoreRootState>(CoreReduxContext);

export default useCoreDispatch;
